import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00a5a716"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "release-log-viewer" }
const _hoisted_2 = { class: "current-release" }
const _hoisted_3 = {
  class: "release-search-count",
  role: "status"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "release-log-results" }
const _hoisted_6 = { class: "release-log-header" }
const _hoisted_7 = { class: "release-log-title" }

import {computed,defineComponent,h,ref} from 'vue'
import type {ReleaseInfo} from '@/utils/release'
import {filterReleaseLogs,highlightReleaseText} from '@/utils/releaseLogSearch'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReleaseLogViewer',
  props: {
    info: {}
  },
  setup(__props: any) {

const props=__props
const keyword=ref('')
const filteredLogs=computed(()=>filterReleaseLogs(props.info.logs,keyword.value))
// 使用文本节点渲染，不将搜索词或更新内容作为HTML插入。
const Highlight=defineComponent({
  props:{text:{type:String,default:''},query:{type:String,default:''}},
  setup:props=>()=>h('span',highlightReleaseText(props.text,props.query).map(part=>part.matched?h('mark',{class:'release-search-mark'},part.text):part.text))
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "当前版本：V" + _toDisplayString(_ctx.info.version), 1),
    _createVNode(_component_a_input, {
      value: keyword.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
      "allow-clear": "",
      maxlength: 100,
      placeholder: "输入版本号、标题或更新内容",
      "aria-label": "搜索版本日志"
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(keyword.value.trim() ? '找到 '+filteredLogs.value.length+' 个版本' : '共 '+filteredLogs.value.length+' 个版本'), 1),
      (keyword.value.trim())
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " · 多个关键词可用空格分开"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!filteredLogs.value.length)
        ? (_openBlock(), _createBlock(_component_a_empty, {
            key: 0,
            description: keyword.value.trim() ? '没有找到匹配的版本记录，请更换关键词' : '暂无版本记录'
          }, null, 8, ["description"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLogs.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.version+'-'+index,
          class: "release-log"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("strong", null, [
              _createVNode(_unref(Highlight), {
                text: 'V'+item.version,
                query: keyword.value
              }, null, 8, ["text", "query"])
            ]),
            _createElementVNode("span", null, _toDisplayString(item.releaseDate), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Highlight), {
              text: item.title,
              query: keyword.value
            }, null, 8, ["text", "query"])
          ]),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.changes, (change, changeIndex) => {
              return (_openBlock(), _createElementBlock("li", { key: changeIndex }, [
                _createVNode(_unref(Highlight), {
                  text: change,
                  query: keyword.value
                }, null, 8, ["text", "query"])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})